var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { Reaction } from '../../../utils/mobx/Reaction';
import { QuestionTypeName } from '../../learnware/LearnwareEnums';
import { runtime } from '../../runtime/Runtime';
import { memoize } from '../../../utils/mobx/decorators/memoize';
export class DirectorQuestion {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        this.ifStageIsEmptyStageFrontalAnswer = new Reaction({
            when: () => runtime.isBrowserRuntime &&
                this.app.topic &&
                !this.app.stage.itemOnStage &&
                !this.app.stage.stageEmerge.isCurrentlyEmerging &&
                this.app.tray.trayAnswers.frontalAnswer,
            action: () => this.stageFrontalAnswer(),
            onlyIfTrue: true,
            setupWhenIdle: true,
        });
        this.ifIsFeebackTimeOver = new Reaction({
            when: () => this.shouldFinishQuestion,
            action: () => this.app.directive.directiveFinishQuestion.finishAnswer(),
            onlyIfTrue: true,
            setupWhenIdle: true,
        });
        this.ifQuestionisCompleteSetCompletedTimestampAndNewState = new Reaction({
            when: () => !!this.question && this.question.answeringState.shouldSetCompletedTimestamp,
            action: () => this.app.directive.directiveCompleteQuestion.setQuestionComplete(),
            onlyIfTrue: true,
            setupWhenIdle: true,
        });
        this.ifQuestionTalkMatchesThenExecute = new Reaction({
            when: () => this.question && this.question.questionType === QuestionTypeName.Talk && this.directiveQuestionTalk.shouldExecute,
            action: () => this.directiveQuestionTalk.executeTalkManner(),
            onlyIfTrue: true,
            setupWhenIdle: true,
        });
    }
    ifStageIsEmptyStageFrontalAnswer;
    ifIsFeebackTimeOver;
    ifQuestionisCompleteSetCompletedTimestampAndNewState;
    ifQuestionTalkMatchesThenExecute;
    get director() {
        return this.parent;
    }
    get app() {
        return this.director.app;
    }
    get question() {
        return this.app.question;
    }
    stageFrontalAnswer() {
        if (runtime.isServerRuntime)
            return;
        if (!this.app.tray.trayAnswers.frontalAnswer)
            return;
        this.app.tray.trayAnswers.frontalAnswer.stageMe();
    }
    get shouldFinishQuestion() {
        return (!!this.app.answer &&
            !!this.app.answer.completeDate &&
            !this.app.answer.finishDate &&
            this.app.answer.question.answeringFeedback.isFeedbackTimeNearlyOver);
    }
    get directiveQuestionTalk() {
        return new runtime.solidPackages.Exotic.classes.DirectiveQuestionTalk(this);
    }
}
__decorate([
    action.bound
], DirectorQuestion.prototype, "stageFrontalAnswer", null);
__decorate([
    memoize
], DirectorQuestion.prototype, "directiveQuestionTalk", null);
